import { createTheme } from '@mui/material'
import { alpha } from '@mui/material/styles'
import { red, } from '@mui/material/colors'
import _ from 'lodash'
// import { ROWS_PER_PAGE_OPTIONS } from 'constants'

const typography = {
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  h1: {
    fontSize: '96px',
    fontWeight: 'light',
    lineHeight: 1.2,
  },
  h2: {
    fontSize: '60px',
    fontWeight: 500,
    lineHeight: 1.3,
  },
  h3: {
    fontSize: '48px',
    fontWeight: 500,
    lineHeight: 1.3,
  },
  h4: {
    fontSize: '34px',
    fontWeight: 500,
    lineHeight: 1.3,
  },
  h5: {
    fontSize: '24px',
    fontWeight: 500,
    lineHeight: 1.3,
  },
  h6: {
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: 1.3,
  },
  body1: {
    fontSize: '16px',
    lineHeight: 1.5,
  },
  body2: {
    fontSize: '14px',
    lineHeight: 1.43,
  },

  heading1: {
    fontSize: '22px',
    fontWeight: 400,
    lineHeight: 1.5
  },

  subtitle1: {
    fontSize: '18px',
    fontWeight: 500,
    letterSpacing: '0.15px',
    lineHeight: '28px',
  },

  button: {
    fontWeight: 500,
  },
}

// Components override settings
const components = palette => ({
  MuiListItemButton: {
    styleOverrides: {
      root: {
        '.appMenu &': {
          borderRadius: '8px',
          marginBottom: '2px',
          color: 'white',
          '&.Mui-selected': {
            backgroundColor: palette.primary.light,
          },
          '&.Mui-selected:hover': {
            backgroundColor: palette.primary.light,
          },
          '&:hover': {
            backgroundColor: palette.primary.dark,
          },
        },
        '.appMenu.collapsed &': {
          borderRadius: '0px',
        },
      },
    },
  },

  MuiToolbar: {
    styleOverrides: {
      root: {
        '.appMenu &': {
          paddingLeft: '10px',
          paddingRight: '10px',
        },
      },
    },
  },

  MuiListItem: {
    styleOverrides: {
      root: {
        marginBottom: 0,
        '&:last-child': {
          marginBottom: 0,
        },
      },
    },
  },

  MuiListItemIcon: {
    styleOverrides: {
      root: {
        '.appMenu &': {
          color: 'white',
          fontSize: '24px',
          alignItems: 'center',
          minWidth: '40px',
        },
        '.appMenu.collapsed &': {
          borderRadius: '0px',
          minWidth: 'auto',
          padding: '2px 4px 2px 4px',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center' 
        },
      },
    },
  },

  MuiDrawer: {
    styleOverrides: {
      paper: {
        '@media (max-width:800px)': {
          width: '100%',
        },
      },
    },
  },

  // MuiDataGrid: {
  // defaultProps: {
  //   disableColumnMenu: true,
  //   disableRowSelectionOnClick: true,
  //   pageSizeOptions: ROWS_PER_PAGE_OPTIONS,
  // },
  // styleOverrides: {
  //   root: { border: 'none' },
  //   columnHeaders: { backgroundColor: palette.action.hover },
  //   columnHeaderTitle: { fontWeight: 700 },
  //   cell: { display: 'flex', alignItems: 'center', borderColor: palette.divider },
  //   row: { '&:hover': { backgroundColor: palette.action.hover } },
  // },
  // },

})

const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#FF9215',
      dark: '#FE7312',
      light: '#FFD655',
      contrastText: '#ffffff',
      contrast: '#ffffff',
    },
    secondary: {
      main: '#1582FF',
      dark: '#225DD8',
      light: '#5AB2FF',
      contrastText: '#ffffff',
    },
    error: {
      main: red[700],
      dark: red[800],
      light: red[400],
      contrastText: '#ffffff',
    },
    warning: {
      main: '#ED6C02',
      dark: '#E65100',
      light: '#FF9800',
      contrastText: '#ffffff',
    },
    success: {
      main: '#2E7D32',
      dark: '#1B5E20',
      light: '#4CAF50',
      contrastText: '#ffffff',
    },
    info: {
      main: '#0288D1',
      dark: '#01579B',
      light: '#03A9F4',
      contrastText: '#ffffff',
    },
    background: {
      default: '#EBEBEB',
      paper: '#ffffff',
    },
    text: {
      primary: alpha('#000000', 0.87),
      secondary: alpha('#000000', 0.6),
      disabled: alpha('#000000', 0.38),
    },
  },
  typography,
  components: components({
    primary: { main: '#FF9215', dark: '#FE7312', light: '#FFD655' },
    text: { primary: alpha('#000000', 0.87) },
  }),
})

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#FF8C00',
      dark: '#C65A00',
      light: '#FFAA4D',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#1582FF',
      dark: '#225DD8',
      light: '#5AB2FF',
      contrastText: '#ffffff',
    },
    error: {
      main: red[400],
      dark: red[600],
      light: red[200],
      contrastText: '#ffffff',
    },
    warning: {
      main: '#FFD54F',
      dark: '#FFA000',
      light: '#FFE082',
      contrastText: 'rgba(0, 0, 0, 0.87)',
    },
    success: {
      main: '#66BB6A',
      dark: '#388E3C',
      light: '#A5D6A7',
      contrastText: 'rgba(0, 0, 0, 0.87)',
    },
    info: {
      main: '#29B6F6',
      dark: '#0288D1',
      light: '#4FC3F7',
      contrastText: 'rgba(0, 0, 0, 0.87)',
    },
    background: {
      default: '#1d1d1d',
      paper: '#222222',
    },
    text: {
      primary: alpha('#ffffff', 0.87),
      secondary: alpha('#ffffff', 0.6),
      disabled: alpha('#ffffff', 0.38),
    },
  },
  typography,
  components: components({
    primary: { main: '#FF8C00', dark: '#C65A00', light: '#FFAA4D' },
    text: { primary: alpha('#ffffff', 0.87) },
  }),
})


const compileTheme = (session, mode) => {
  const defaultTheme = mode === 'dark' ? darkTheme : lightTheme;

  if (!session || (!session.theme?.light && !session.theme?.dark)) {
    return defaultTheme;
  }

  const baseTheme = mode === 'dark' ? darkTheme : lightTheme;
  const themeTemplate = mode === 'dark' ? session.theme?.dark : session.theme?.light;

  try {
    const compiled = _.template(themeTemplate);
    const cleanedTemplateString = compiled({ red, alpha })
      .replace(/,\s*}/g, '}')
      .replace(/,\s*]/g, ']');

    const parsedTheme = JSON.parse(cleanedTemplateString);

    return createTheme({
      ...baseTheme,
      palette: {
        ...baseTheme.palette,
        ...parsedTheme.palette,
        mode,
      },
      typography: {
        ...baseTheme.typography,
        ...parsedTheme.typography,
      },
      components: {
        ...baseTheme.components,
        ...components(parsedTheme.palette || baseTheme.palette),
      },
      logos: parsedTheme.logos,
    });
  } catch (error) {
    console.error('Error parsing theme:', error);
    return defaultTheme;
  }
};


export {
  lightTheme,
  darkTheme,
  compileTheme,
}
